import { render, staticRenderFns } from "./Topbar.component.vue?vue&type=template&id=dbba5272&"
import script from "./Topbar.component.vue?vue&type=script&lang=js&"
export * from "./Topbar.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports